(function (w, d) {
  'use strict';

  if (w.BvManualConsentGateLoaded) return;
  w.BvManualConsentGateLoaded = true;

  const configElement = d.getElementById('BvConsentConfig');
  let config = {};
  try {
    config = JSON.parse(configElement ? configElement.textContent : '{}');
  } catch (error) {
    config = {};
  }

  const denied = {
    analytics: false,
    marketing: false,
    preferences: false,
    sale: false
  };
  const loaded = { gtm: false, hotjar: false };
  let lastGoogleState = '';
  let reloadScheduled = false;
  let featurePending = false;
  let featureRequests = 0;
  let readinessTimer = null;
  let readinessDeadline = 0;

  function googleState(state) {
    return {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: state.marketing ? 'granted' : 'denied',
      ad_user_data: state.marketing && state.sale ? 'granted' : 'denied',
      ad_personalization: state.marketing && state.sale ? 'granted' : 'denied',
      functionality_storage: state.preferences ? 'granted' : 'denied',
      personalization_storage: state.preferences ? 'granted' : 'denied',
      security_storage: 'granted'
    };
  }

  lastGoogleState = JSON.stringify(googleState(denied));

  function hasLegacyProvider() {
    return Boolean(d.querySelector('loess-cookie-banner')) || Array.from(d.scripts).some(function (script) {
      const source = script.getAttribute('src') || script.getAttribute('data-src') || '';
      return /consentmo_cookie_consent\.js(?:\?|$)/i.test(source);
    });
  }

  function readState() {
    if (!w.BvConsentDefaultsQueued || !Array.isArray(w.dataLayer)) {
      return { state: denied, reason: 'defaults-unavailable' };
    }
    if (config.nativeConsentReady !== true) {
      return { state: denied, reason: 'staged' };
    }
    if (hasLegacyProvider()) {
      return { state: denied, reason: 'legacy-provider' };
    }
    if (!w.privacyBanner || typeof w.privacyBanner.showPreferences !== 'function') {
      return { state: denied, reason: 'native-banner-unavailable' };
    }

    const api = w.Shopify && w.Shopify.customerPrivacy;
    if (!api || ['currentVisitorConsent', 'analyticsProcessingAllowed', 'marketingAllowed', 'preferencesProcessingAllowed', 'saleOfDataAllowed'].some(function (method) {
      return typeof api[method] !== 'function';
    })) {
      return { state: denied, reason: 'privacy-api-unavailable' };
    }

    try {
      const choice = api.currentVisitorConsent();
      return {
        state: {
          analytics: choice.analytics === 'yes' && api.analyticsProcessingAllowed() === true,
          marketing: choice.marketing === 'yes' && api.marketingAllowed() === true,
          preferences: choice.preferences === 'yes' && api.preferencesProcessingAllowed() === true,
          sale: api.saleOfDataAllowed() === true
        },
        reason: 'ready'
      };
    } catch (error) {
      return { state: denied, reason: 'privacy-api-error' };
    }
  }

  function existingScript(host, path, id) {
    return Array.from(d.scripts).some(function (script) {
      try {
        const url = new URL(script.getAttribute('src') || '', d.baseURI);
        return url.hostname === host && url.pathname === path && (!id || url.searchParams.get('id') === id);
      } catch (error) {
        return false;
      }
    });
  }

  function loadGtm() {
    if (loaded.gtm || config.gtmId !== 'GTM-WRLXL6DN') return;
    loaded.gtm = true;
    if (existingScript('www.googletagmanager.com', '/gtm.js', config.gtmId)) return;
    w.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = d.createElement('script');
    script.id = 'BvManualGtm';
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(config.gtmId);
    d.head.appendChild(script);
  }

  function loadHotjar() {
    if (loaded.hotjar || config.hotjarId !== 5280950 || config.hotjarVersion !== 6) return;
    if (w._hjSettings && w._hjSettings.hjid !== config.hotjarId) return;
    loaded.hotjar = true;
    if (existingScript('static.hotjar.com', '/c/hotjar-' + config.hotjarId + '.js')) return;
    if (typeof w.hj !== 'function') {
      w.hj = function () { (w.hj.q = w.hj.q || []).push(arguments); };
    }
    w._hjSettings = { hjid: config.hotjarId, hjsv: config.hotjarVersion };
    const script = d.createElement('script');
    script.id = 'BvManualHotjar';
    script.async = true;
    script.src = 'https://static.hotjar.com/c/hotjar-' + config.hotjarId + '.js?sv=' + config.hotjarVersion;
    d.head.appendChild(script);
  }

  function updatePreferences(reason) {
    d.querySelectorAll('[data-bv-cookie-preferences-control]').forEach(function (control) {
      control.hidden = config.nativeConsentReady !== true || reason === 'legacy-provider' || (reason === 'defaults-unavailable' && hasLegacyProvider());
      const status = control.querySelector('[data-bv-cookie-preferences-status]');
      if (status) {
        status.textContent = !control.hidden && reason === 'native-banner-unavailable' ? status.getAttribute('data-unavailable-message') || '' : '';
      }
    });
  }

  function refresh() {
    const result = readState();
    const state = result.state;
    const google = googleState(state);
    const signature = JSON.stringify(google);
    if (signature !== lastGoogleState && typeof w.gtag === 'function') {
      w.gtag('consent', 'update', google);
      lastGoogleState = signature;
    }

    const gtmAllowed = state.analytics && state.marketing && state.preferences && state.sale;
    const revoked = (loaded.gtm && !gtmAllowed) || (loaded.hotjar && !state.analytics);
    d.documentElement.setAttribute('data-bv-consent-gate', result.reason);
    d.documentElement.setAttribute('data-bv-consent-state', signature);
    d.documentElement.setAttribute('data-bv-manual-gtm', gtmAllowed ? 'eligible' : 'blocked');
    d.documentElement.setAttribute('data-bv-manual-hotjar', state.analytics ? 'eligible' : 'blocked');
    updatePreferences(result.reason);

    if (revoked) {
      if (!reloadScheduled) {
        reloadScheduled = true;
        w.setTimeout(function () { w.location.reload(); }, 0);
      }
      return result;
    }
    if (reloadScheduled) return result;
    if (gtmAllowed) loadGtm();
    if (state.analytics) loadHotjar();
    return result;
  }

  function cancelReadiness() {
    if (readinessTimer !== null) {
      w.clearTimeout(readinessTimer);
      readinessTimer = null;
    }
  }

  function requestPrivacyApi() {
    const shopify = w.Shopify;
    if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function' && !featurePending && featureRequests < 3) {
      featurePending = true;
      featureRequests += 1;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          featurePending = false;
          initialize(false);
        });
      } catch (error) {
        featurePending = false;
      }
    }
  }

  function initialize(restart) {
    if (restart === true) readinessDeadline = Date.now() + 10000;
    const result = refresh();
    if (config.nativeConsentReady !== true || reloadScheduled || ['ready', 'legacy-provider', 'defaults-unavailable'].includes(result.reason)) {
      cancelReadiness();
      return;
    }
    requestPrivacyApi();
    if (readState().reason === 'ready') {
      refresh();
      cancelReadiness();
      return;
    }
    if (d.visibilityState === 'hidden' || Date.now() >= readinessDeadline) {
      cancelReadiness();
      return;
    }
    if (readinessTimer !== null) return;
    readinessTimer = w.setTimeout(function () {
      readinessTimer = null;
      initialize(false);
    }, 250);
  }

  w.addEventListener('pageshow', function () { initialize(true); });
  w.addEventListener('pagehide', cancelReadiness);
  w.addEventListener('focus', function () { initialize(true); });
  d.addEventListener('visibilitychange', function () {
    if (d.visibilityState === 'visible') initialize(true);
    else cancelReadiness();
  });
  d.addEventListener('visitorConsentCollected', function () { initialize(false); });
  d.addEventListener('shopify:section:load', function () { initialize(false); });
  d.addEventListener('load', function (event) {
    if (event.target && event.target.tagName === 'SCRIPT') initialize(false);
  }, true);
  d.addEventListener('click', function (event) {
    const button = event.target && typeof event.target.closest === 'function' && event.target.closest('[data-bv-cookie-preferences]');
    if (!button || config.nativeConsentReady !== true || hasLegacyProvider()) return;
    const control = button.closest('[data-bv-cookie-preferences-control]');
    const status = control && control.querySelector('[data-bv-cookie-preferences-status]');
    if (status) status.textContent = '';
    function unavailable() {
      if (status) status.textContent = status.getAttribute('data-unavailable-message') || '';
    }
    if (!featurePending) featureRequests = 0;
    initialize(true);
    if (!w.privacyBanner || typeof w.privacyBanner.showPreferences !== 'function') {
      unavailable();
      return;
    }
    button.setAttribute('aria-busy', 'true');
    try {
      Promise.resolve(w.privacyBanner.showPreferences()).catch(unavailable).finally(function () {
        button.removeAttribute('aria-busy');
      });
    } catch (error) {
      unavailable();
      button.removeAttribute('aria-busy');
    }
  });

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', function () { initialize(true); }, { once: true });
  } else {
    initialize(true);
  }
})(window, document);
